import {  useState, useEffect } from 'react';
// @mui
import { MenuItem,
  TextField, 
  Card,
  CardContent,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
// utils
import axios from "../../../utils/axios";
// context
import usePlannerSettings from "../../../contexts/PlannerContext";
// 
import { useTranslation } from "react-i18next";

// ----------------------------------------------------------------------

export default function SettingPlannerLines() {
  const theme = useTheme();

  const { line, setLine, setHeight } = usePlannerSettings();

  const [changeLines, setChangeLines] = useState([]);
  const [selectedLine, setSelectedLine] = useState(0);

  const { t, i18n } = useTranslation();

  const style = {
    "& > *": { my: "8px !important" },
  };

  const getChangeLines = async () => {
    try {
      const res = await axios.post(`/planner/materials/${line}/changeLines`);

      setChangeLines(res.data.lines);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (line) {
      getChangeLines();
    }
  }, [line]);

  useEffect(() => {
    if (changeLines) {
      setSelectedLine(line);
    }
  }, [changeLines]);

  function handleChange(element, value) {
    setSelectedLine(value);
    setLine(value);
    const height = changeLines.find((item) => item.material.id === value);
    setHeight(height.id);
  }

  return (
    <>
      <Card sx={{ margin: "16px 0", border: '1px solid black', borderRadius: '30px', borderColor: theme.palette.primary.main }}>
        <CardContent title="Type" sx={style}>
          <Typography sx={{ fontWeight: 'bold' }}>
            {t("settings.drawer.lines.select")}
          </Typography>
          <TextField select fullWidth name="changeLines" label={t("settings.drawer.lines.select_label")}  onChange={(e) => handleChange(e.target.name, e.target.value)} value={selectedLine}>
            {changeLines && changeLines.map((line) => (
              <MenuItem key={line.material.id} value={line.material_id}>
                {t(`${line.material.nicename}`)}
              </MenuItem>
            ))}
          </TextField>
        </CardContent>
      </Card>
    </>
  );
}
